module.exports = __webpack_public_path__ + "static/media/hotelIcon.03aca1b8.png";